import MainCard from "./MainCard";
import FactorSection from "./FactorSection";
import { apiGetAccountCard, apiGetFactorWithDetailExcel } from "api/reportApi";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { apiPersonsList } from "api/personApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { useSearchParams } from "react-router-dom";
import { setQueryParam } from "helpers/queryParam";
import useDateState from "helpers/useDateState";
import { useAppDispatch, useAppSelector } from "store/store";
import { ExportContainer, Item, StyledListItemIcon, StyledListItemText } from "../../Table/ExportBotton";
import SnippetFolderIcon from "@mui/icons-material/SnippetFolder";
import AccountCardPrint from "pages/report/subReports/AccountCardPrint";

interface Props {
    tab?: string;
    options?: any;
    onChange?: (state: any) => void;

}

interface FD {
    personId?: number | string | null;
    projectId?: number;
    tab?: string;
    search?: any;
    sort?: any;
}

const PersonalAccountCardComponent = (props: Props) => {
    const { options, onChange } = props;
    const dispatch = useAppDispatch();
    const [searchParams] = useSearchParams();
     const { toDate, fromDate, setDates } = useDateState();
    
    const store = useAppSelector((x: any) => x);
    const { person: psn } = store.reportReducer;
    const { token } = store.businessReducer.business;
    // const { allPerson } = store.personReducer;
    // const { projects } = store.projectReducer;
    const pagination = store.paginationReducer;
    const [formData, setFormData] = useState<FD>({
        tab: props.tab,
        ...options,
        personId: searchParams.get("personId"),
    });
    const [persons, setPersons] = useState<any>([]);
    const [person, setPerson] = useState<any>({});
    const { personId, projectId, tab, search, sort } = formData;
    const [DataToPrint, setDataToPrint] = useState(null)

    // useEffect(() => {
    // dispatch(apiPersonsList(token, "allPerson", (res: any) => setPersons(res)));
    // dispatch(apiGetProjects(token));
    // }, [token]);
    const downloadFactorWithDetailsExcel = () => {
        dispatch(
            apiGetFactorWithDetailExcel(token, personId)
        )
    }

    useEffect(() => setFormData((x) => ({ ...x, tab: props.tab })), [props.tab]);
    useEffect(() => setFormData((x) => ({ ...x, ...options })), [options]);
    // useEffect(() => submit([fromDate, toDate]), [formData.personId]);
    useEffect(() => onChange && onChange({ person, dates: { fromDate, toDate } }), [person, toDate, fromDate]);
    useEffect(() => {
        let pid = 0;
        if (personId && typeof personId === "string") pid = parseInt(personId);
        if (personId && typeof personId === "number") pid = personId;
        psn && pid === psn.id && setPerson(psn);
    }, [personId, psn]);

    // useEffect(() => {
    //     submit();
    // }, [pagination]);

    function submit(date: string[]) {
        let { search, sort } = pagination;
        let params: any = { personId };
        let data: any = {};
        if (projectId) params.projectId = projectId;
        if ( date[0] && date[1]) {
            data.column = "createdAt";
            data.columnType = "date";
            data.primarySearch = date[0];
            data.secondarySearch = date[1];
            data.filterType = "7";
        }
        //@ts-ignore
        dispatch(apiGetAccountCard({ pagination, search, sort, token, options: data, params, tab, callBack: (res: any) => setDataToPrint(res) }));
    }

    return (
        <>
            <div className="flex gap-4 my-10 flex-wrap">
                <div style={{ width: 245 }}>
                    <BasicDateInput
                        range
                        placeholder="کل سال مالی"
                        onChange={(dates) => { 
                            setDates(dates);
                             submit(dates ? dates : []) }}
                        defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                    />
                </div>
                <BasicSelect
                    key={personId}
                    options={persons}
                    placeholder={(person && person.label) || "شخص"}
                    defaultValue={typeof personId === "string" ? parseInt(personId) : personId}
                    onChange={(val) => {
                        setQueryParam("personId", val);
                        setFormData((x) => ({ ...x, personId: val }));
                        submit([toDate, fromDate])

                    }}
                    style={{ minWidth: 245 }}
                    withSearch
                    withRefresh
                    // @ts-ignore
                    refreshList={() => { if (persons.length === 0) dispatch(apiPersonsList(token, "allPerson", (res: any) => setPersons(res))) }}
                />
                <div>
                    <ExportContainer>
                        <Item disableRipple onClick={() => downloadFactorWithDetailsExcel()}>
                            <StyledListItemIcon>
                                <SnippetFolderIcon color="success" />
                            </StyledListItemIcon>
                            <StyledListItemText> دانلود اکسل فاکتور ها با جزئیات</StyledListItemText>
                        </Item>
                    </ExportContainer>


                </div>
                <div>
                    <AccountCardPrint  fromDate={fromDate} toDate={toDate} />
                </div>
                {/* <BasicSelect
          options={projects}
          placeholder="پروژه"
          onChange={(val) => setFormData((x) => ({ ...x, projectId: val }))}
          style={{ width: 245 }}
        /> */}
            </div>
            <Grid container spacing={4} style={{ justifyContent: "space-between", marginBottom: "20px" }}>
                {person && (
                    <>
                        <Grid item xs={12} md={7}>
                            <MainCard data={person} />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <FactorSection />
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
};

export default PersonalAccountCardComponent;
